import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractComponent } from '../../../../shared/components/abstract-component/abstract.component';
import { BatchAuftragDetailEntryMeta } from '../../../../core/batch-auftrag-api';
import { ContentHeaderComponent } from '../../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../../shared/components/title/title.component';
import { AuftragKopfdatenComponent } from './auftrag-kopfdaten/auftrag-kopfdaten.component';
import { RubrikComponent } from '../../../../shared/components/rubrik/rubrik.component';
import { FormsModule } from '@angular/forms';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { AuftragNewComponent } from '../auftrag-new/auftrag-new.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-bash-auftrag-detail',
  templateUrl: './auftrag-detail.component.html',
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    AuftragKopfdatenComponent,
    RubrikComponent,
    FormsModule,
    MetaDisablerDirective,
    MetaValidatorDirective,
    AuftragNewComponent,
    TranslatePipe
  ]
})
export class AuftragDetailComponent extends AbstractComponent implements OnInit {
  auftragEntry: BatchAuftragDetailEntryMeta;

  constructor(private route: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.addSub(
      this.route.data.subscribe((data) => {
        this.auftragEntry = data.entry;
      })
    );
  }
}
